import React from 'react';

const NDAPreviewButton = ({ onToggle, ...restProps }) => (
  <a className="sample-nda-link" onClick={() => onToggle(restProps)}>View sample NDA</a>
);

export default NDAPreviewButton;



// WEBPACK FOOTER //
// ./pap/components/common/nda_preview_button.jsx